import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialFacebookSvg } from "./IconSocialFacebookSvg.mjs";
const IconSocialFacebook = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialFacebookSvg, ...svgProps }) });
export {
  IconSocialFacebook
};
